<div class="list-buttons fx-layout-row fx-layout-align-start-m fx-layout-align-center-x fx-gap-10">
  @if (showButtons) {
    <div>
      @if (!isTribunalTab) {
        <div>
          <button mat-icon-button (click)="expandCollapseAll(false)" title="Collapse Details">
            <mat-icon>expand_less</mat-icon>
          </button>
          <button mat-icon-button (click)="expandCollapseAll(true)" title="Expand Details">
            <mat-icon>expand_more</mat-icon>
          </button>
          <button mat-icon-button (click)="addNew('Upload Document')" color="primary">
            <mat-icon title="Upload Document">cloud_upload</mat-icon>
          </button>
          <button mat-icon-button (click)="addNew('Note')" color="primary">
            <mat-icon title="Add Note">note</mat-icon>
          </button>
        </div>
      }
    </div>
  }

  @if (displayDownloadTribunalPack) {
    <button mat-raised-button (click)="downloadTribunalPack()" [title]="downloadTribunalPackButtonTitle">
      <mat-icon>cloud_download</mat-icon>
      Download Pack
    </button>
  }
</div>



<div [ngClass]="{ 'table-container': activityLevel != 4, 'dashboard-table-container': activityLevel == 4 }">
  @if (activityListService.itemsCount) {
    <table mat-table #table [dataSource]="activityListService.itemList" matSort matSortActive="activityDate"
      matSortDirection="desc" matSortDisableClear multiTemplateDataRows>
      <ng-container matColumnDef="activityTypeName" sticky>
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <mat-icon>{{ iconFromActivityType(row.dataModel.systemActivityType) }}</mat-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="createdByInitials">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Created By</th>
        <td mat-cell matTooltip="{{ row.dataModel.createdBy }}" matTooltipDelay="750" matTooltipPosition="above"
          *matCellDef="let row">
          <span class="createdbyDot">{{ row.dataModel.createdByInitials }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="summary">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Description</th>
        <td mat-cell matTooltip="{{ row.dataModel.summary }}" matTooltipDelay="750" matTooltipPosition="above"
          *matCellDef="let row">
          {{ row.dataModel.summary }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row" class="right">
          <icon-action-button-list [data]="row.itemId" class="action-icons" [actionItems]="row.processActions"
          (onInvokeAction)="doIconButtonAction($event)"></icon-action-button-list>
        </td>
      </ng-container>
      <ng-container matColumnDef="activityDate">
        <th mat-header-cell mat-sort-header *matHeaderCellDef start="desc">Activity Date</th>
        <td mat-cell *matCellDef="let row">
          {{ row.dataModel.activityDate | date: 'dd/MM/yyyy HH:mm' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
          <div class="expanded-detail" [@detailExpand]="row.expanded ? 'expanded' : 'collapsed'">
            @if (ShowDefaultContents(row)) {
              <div class="expanded-detail-content"
              [innerHTML]="convertString(row?.dataModel.detail) | safeHtml"></div>
            }
            @if (ShowDocumentPackContents(row)) {
              <div class="expanded-detail-content">
                <activity-document-pack-list [listData]="row?.dataModel.detail"></activity-document-pack-list>
              </div>
            }
            @if (ShowInboundEmailContents(row)) {
              <div class="expanded-detail-content">
                <activity-email-attachment-list
                [listData]="row?.dataModel.detail.emailAttachments"></activity-email-attachment-list> <br>
                <div [innerHTML]="row?.dataModel.detail.content | safeHtml"></div>
              </div>
            }
            @if (ShowFilePreview(row)) {
              <div class="expanded-detail-content">
                <activity-file-preview [uniqueIdentifier]="row?.dataModel.uniqueIdentifier"
                [visible]="row.expanded"></activity-file-preview>
              </div>
            }
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selectRow(row); toggleExpanded(row)"
      class="table-data-row" [ngClass]="{ 'table-row-selected': row.dataModel.id == selectedRowId }"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    </table>
  }

  @if (!activityListService.itemsCount || activityListService.itemsCount <= 0 ) {
    <div class="fx-layout-align-center-m fx-layout-align-center-x case-list-message"
      >
      <label>
        {{ noItemsMessage }}
      </label>
    </div>
  }

</div>

@if (showButtons) {
  <div>
    @if (activityListService.itemsCount) {
      <mat-paginator [length]="activityListService.itemsCount" [pageIndex]="activityListService.paginatorIndex"
        [pageSize]="activityListService.listRequest.pageSize" showFirstLastButtons="true"
      ></mat-paginator>
    }
  </div>
}